
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import pauseVideo from 'Helpers/Video/VideoHelpers';

const BundleCarouselButtons = ({ slideNumber, totalGameCount, setSlideNumber }) => {
  const scrollToTop = () => {
    const carouselContent = document.getElementById('carousel-content');
    if (carouselContent) carouselContent.scrollTop = 0;
  };

  const changeSlide = (direction) => {
    if (direction === 'left') {
      setSlideNumber(slideNumber === 1 ? totalGameCount : slideNumber - 1);
    } else if (direction === 'right') {
      setSlideNumber(slideNumber === totalGameCount ? 1 : slideNumber + 1);
    }
  };

  const handleChange = (direction) => {
    scrollToTop();
    pauseVideo();
    changeSlide(direction);
  };

  return (
    <div className="carousel-buttons-container">
      <div className="carousel-count">
        <FormattedMessage
          id="bundlecarouselbuttons.pagenumber"
          defaultMessage="{current} of {total}"
          values={{
            current: slideNumber,
            total: totalGameCount,
          }}
        />
      </div>
      <div>
        <Button
          aria-label="Previous"
          className="carousel-button"
          onClick={() => handleChange('left')}
        >
          <FontAwesomeIcon icon={faChevronLeft} title="Previous" />
        </Button>
        <Button
          aria-label="Next"
          className="carousel-button"
          onClick={() => handleChange('right')}
        >
          <FontAwesomeIcon icon={faChevronRight} title="Next" />
        </Button>
      </div>
    </div>
  );
};

export default BundleCarouselButtons;

